import { z } from 'zod/v4';

import { userRoleSchema } from '../enums';
import { siteSchema } from '../site';
import { teamWithConfigSchema } from '../team';
import { userSettingsSchema } from '../user-settings';
import { columns } from './columns';

export const userSchema = z.object(columns);

export type User = z.output<typeof userSchema>;

export const userWithSettingsSchema = z.object({
  ...userSchema.shape,
  userSettings: userSettingsSchema.nullable(),
  teams: z.array(
    // NOTE: The true Database relationship is an explicit join resulting in a structure
    // like { teams: [{ team: { ...team }, }, {team: { ...team}}, ...] } (note the extra nested {team: { ...teamData}} object)
    // This type reflects that structure after it has been flattened to just { teams: [ {...teamData}, {...teamData}, ...]}
    z.object({
      ...teamWithConfigSchema.shape,
      site: siteSchema.pick({
        uuid: true,
        name: true,
        code: true,
      }),
    }),
  ),
  role: userRoleSchema,
});

export type UserWithSettings = z.output<typeof userWithSettingsSchema>;
